module.exports = __webpack_public_path__ + "static/media/005 color panel.a45f7445.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redbox/005 color panel.png
// module id = 597
// module chunks = 0